import { Col, Menu, Row, Space } from "antd";
import { Menu as MenuIcon, BarChart3, Users, CreditCard, Mail, KeyRound } from "lucide-react";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import { getProjectService } from "../../backend";
import { isApiKeysEnabled } from "../../backend/api-keys";
import { useRecoilValue } from "recoil";
import { currentProjectState } from "../../recoil/project";
import PageContentWrapper from "../../components/PageContentWrapper";
import { PageHeader } from "@ant-design/pro-layout";

export default function ProjectSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { projectId } = useParams();
    const [activeTab, setActiveTab] = useState("general");
    const currentProject = useRecoilValue(currentProjectState);

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "general");

        const loadData = async () => {
            await getProjectService().getUsers(projectId!);
        }
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return (
        <PageContentWrapper
            size="large"
            header={
                <PageHeader
                    title="Project Settings"
                />
            }
        >
            <Row gutter={24}>
                <Col span={6}>
                    <Menu
                        mode="inline"
                        className="ant-card-bordered"
                        selectedKeys={[activeTab]}
                        onSelect={(item) => {
                            navigate(item.key);
                            setActiveTab(item.key);
                        }}
                        items={[
                            {
                                key: "general",
                                label: <Space>
                                    <MenuIcon size={16} style={{ display: 'flex', alignItems: 'center' }} />
                                    General
                                </Space>
                            },
                            {
                                key: "cost-report",
                                label: <Space>
                                    <Mail size={16} style={{ display: 'flex', alignItems: 'center' }} />
                                    Cost Report
                                </Space>
                            },
                            {
                                key: "usage",
                                label: <Space>
                                    <BarChart3 size={16} style={{ display: 'flex', alignItems: 'center' }} />
                                    Plan usage
                                </Space>
                            },
                            {
                                key: "members",
                                label: <Space>
                                    <Users size={16} style={{ display: 'flex', alignItems: 'center' }} />
                                    Members
                                </Space>
                            },
                            ...(isApiKeysEnabled(projectId!) ? [{
                                key: "api-keys",
                                label: <Space>
                                    <KeyRound size={16} style={{ display: 'flex', alignItems: 'center' }} />
                                    API keys
                                </Space>
                            }] : []),
                            {
                                key: "billing",
                                label: <Space>
                                    <CreditCard size={16} style={{ display: 'flex', alignItems: 'center' }} />
                                    Billing
                                </Space>
                            }
                        ]}
                    />
                </Col>
                <Col span={18}>
                    <Outlet context={{ projectDetails: currentProject }} />
                </Col>
            </Row >
        </PageContentWrapper>
    )
}